<template>
  <div class="auth-header">
    <h1 class="auth-header__title">
      {{ props.title }}
    </h1>
    <div v-if="subtitle" class="auth-header__subtitle">
      {{ props.subtitle }}
    </div>
    <div v-if="props.additionalText" class="auth-header__additional">
      {{ props.additionalText }}
    </div>
  </div>
</template>

<script lang="ts" setup>
interface Props {
  title: string
  subtitle?: string
  additionalText?: string
}
const props = defineProps<Props>()
</script>

<style lang="scss" scoped>
.auth-header {
  &__title {
    @include typo-h1;

    overflow-wrap: break-word;
    color: var(--color-foreground-primary);
  }

  &__subtitle,
  &__additional {
    @include typo-subtitle;

    margin-top: rem(12px);
  }

  &__additional {
    margin-top: rem(32px);
  }
}
</style>
